import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { CountriesTypes } from '../Types';

const machine = Machines.onGetListCountry.machine;

export const getListCountry = (
  params?: CountriesTypes.CountriesServiceRequestType,
): Promise<CountriesTypes.ICountriesServiceResponse> => {
  return callServiceMachine(machine, params);
};

export default { getListCountry };
